<template>
  <q-markup-table :class="className" dense flat square>
    <thead v-if="!hideHeader" class="bg-primary-10 text-neutral">
      <tr>
        <th
          v-for="({ align, label }, index) in columns"
          :key="index"
          :class="`text-${align || 'left'}`"
          scope="col"
        >
          {{ label }}
        </th>
      </tr>
    </thead>
    <tbody v-if="rows.length">
      <tr v-for="(row, rowIndex) in rows" :key="row._id">
        <td
          v-for="(column, index) in columns"
          :key="index"
          :class="`text-${column?.align || 'left'}`"
        >
          <span
            v-if="column.format"
            :class="column.cellClass || 'text-neutral'"
            @click="column.onClick && column.onClick(row)"
            v-html="
              column.format(
                column.field === 'rowIndex' ? rowIndex : row[column.field],
                row,
                entity,
              )
            "
          >
          </span>
          <span
            v-else
            :class="column.cellClass || 'text-neutral'"
            @click="column.onClick && column.onClick(row)"
          >
            {{ column.field === "rowIndex" ? rowIndex : row[column.field] }}
          </span>
        </td>
      </tr>
    </tbody>
    <tbody v-else>
      <tr>
        <td :colspan="columns.length">{{ noDataMessage }}</td>
      </tr>
    </tbody>
  </q-markup-table>
</template>

<script setup>
const props = defineProps({
  columns: {
    type: Array,
    default: () => [],
  },
  entity: {
    type: Object,
    default: () => ({}),
  },
  hideHeader: {
    type: Boolean,
    default: false,
  },
  rows: {
    type: Array,
    default: () => [],
  },
  noDataMessage: {
    type: String,
    default: "No data",
  },
  className: {
    type: String,
    default: "inline-block",
  },
});

const width = computed(() => {
  if (props.className === "full-width") {
    return "100%";
  }

  return "auto";
});
</script>

<style lang="scss" scoped>
.q-markup-table {
  :deep(.q-table) {
    width: v-bind(width);
  }

  &.q-table--dense {
    :deep(.q-table) {
      thead {
        tr {
          height: 40px;
          th {
            height: 40px;
          }
        }
      }

      tbody {
        tr {
          height: 40px;
          td {
            height: 40px;
          }
        }
      }
    }
  }
}
</style>
